var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReply = function SvgReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 18.577v-3.5a3.13 3.13 0 0 0-.952-2.298 3.13 3.13 0 0 0-2.298-.952H6.373l3.85 3.85-1.07 1.054L3.5 11.077l5.654-5.654 1.069 1.054-3.85 3.85h9.377q1.97 0 3.36 1.39t1.39 3.36v3.5z"
  })));
};
export default SvgReply;